import { Mail, Phone, MessageCircle, BarChart3, Send, Workflow } from "lucide-react";

const features = [
  {
    icon: Mail,
    title: "Email marketing",
    desc: "Design campaigns, send broadcasts, and nurture leads with sequences — all from the same contact record.",
  },
  {
    icon: Phone,
    title: "Voice & calling",
    desc: "Click-to-call, call logging, and recording built right in. Connect your number and start conversations instantly.",
  },
  {
    icon: MessageCircle,
    title: "Two-way SMS",
    desc: "Text leads and customers from the same inbox. Templates, scheduled sends, and full conversation history included.",
  },
  {
    icon: Send,
    title: "Multi-channel sequences",
    desc: "Mix email, SMS, and calls in one cadence. Reach every prospect on the channel they actually respond to.",
  },
  {
    icon: BarChart3,
    title: "Unified analytics",
    desc: "Track opens, clicks, replies, connects, and conversions across every channel in one dashboard.",
  },
  {
    icon: Workflow,
    title: "Automation",
    desc: "Auto-enroll leads into campaigns, rotate them between reps, and trigger follow-ups based on any signal.",
  },
];

const Features = () => {
  return (
    <section id="features" className="py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">Features</span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            One CRM. Every channel your customers use.
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Email marketing, voice, and SMS in one platform — so your team can reach prospects however they prefer.
          </p>
        </div>
        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <div
              key={f.title}
              className="group rounded-2xl border border-border bg-card p-7 shadow-card transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-elegant"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-gradient-primary group-hover:text-primary-foreground">
                <f.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold text-secondary">{f.title}</h3>
              <p className="mt-2 text-muted-foreground">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
